<template>
  <div v-if="testData.testType === TestTypes.Policies">
    <a class="block mb-4" href="javascript:;" @click="showPoliciesIntroductionAlert">
      View Introduction
    </a>
    <a class="block mb-4" href="javascript:;" @click="showPoliciesCriticalAlert">
      View Critical Information
    </a>
    <a class="block mb-4" href="javascript:;" @click="showPoliciesBasicAlert">
      View Basic Information
    </a>
    <a class="block mb-4" href="javascript:;" @click="showPoliciesScoringAlert">
      View Scoring Information
    </a>
  </div>
  <div v-else-if="testData.testType === TestTypes.Standards">
    <a class="block mb-4" href="javascript:;" @click="showStandardsIntroductionAlert">
      View Introduction
    </a>
    <a class="block mb-4" href="javascript:;" @click="showStandardsBasicAlert">
      View Basic Information
    </a>
    <a class="block mb-4" href="javascript:;" @click="showStandardsScoringAlert">
      View Scoring Information
    </a>
  </div>
</template>

<script>
  import { TestTypes } from '@resources/scripts/models/enums';
  import { createNamespacedHelpers } from 'vuex';
  import axios from 'axios';
  const { mapGetters } = createNamespacedHelpers('tests');

  export default {
    data() {
      return {
        TestTypes,
        modalContentData: [],
      };
    },

    computed: {
      ...mapGetters([
        'testData',
      ]),
    },

    mounted() {
      this.getModalContents();
    },

    methods: {
      async getModalContents() {
        const { data } = await axios.get('/api/tests/modal-content');
        this.modalContentData = data;
      },

      showPoliciesCriticalAlert() {
        this.$dialog.alert({
          title: 'Critical Information',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_POLICIES_CRITICAL_INFO').value,
        });
      },

      showPoliciesIntroductionAlert() {
        this.$dialog.alert({
          title: 'Introduction',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_POLICIES_INTRODUCTION_INFO').value,
        });
      },

      showPoliciesBasicAlert() {
        this.$dialog.alert({
          title: 'About the Test',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_POLICIES_ABOUT_TEST_INFO').value,
        });
      },

      showPoliciesScoringAlert() {
        this.$dialog.alert({
          title: 'Scoring Information',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_POLICIES_SCORING_INFO').value,
        });
      },

      showStandardsIntroductionAlert() {
        this.$dialog.alert({
          title: 'Introduction',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_STANDARDS_INTRODUCTION_INFO').value,
        });
      },

      showStandardsBasicAlert() {
        this.$dialog.alert({
          title: 'About the Test',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_STANDARDS_ABOUT_TEST_INFO').value,
        });
      },

      showStandardsScoringAlert() {
        this.$dialog.alert({
          title: 'Scoring Information',
          width: 800,
          confirmText: 'Close',
          message: this.modalContentData.find(x => x.key === 'TEST_MODAL_STANDARDS_SCORING_INFO').value,
        });
      },
    },
  };
</script>